/*
=======================================================
  FILE 3 OF 3 — JAVASCRIPT FOR DAWN THEME

  HOW TO ADD TO YOUR THEME:
    1. In Shopify Admin → Online Store → Themes → Edit code
    2. Under Assets, click "Add a new asset"
    3. Create file named: injoy-megamenu.js
    4. Paste this entire file in
    5. In layout/theme.liquid, just before </body>, add:
       <script src="{{ 'injoy-megamenu.js' | asset_url }}" defer></script>

  HOW TO FILL IN YOUR DATA:
    For each brand object below, replace the placeholder
    values with your real content:

    logoUrl    → Already in your HTML block (File 1)
                 This is only used here as a reference label
    productImg → Shopify CDN URL of the featured product photo
                 Go to Admin → Files, upload each image,
                 then click the image to copy its CDN URL
    href       → URL of the brand collection page
                 e.g. "/collections/starkey"
    badge      → Short promo label e.g. "NEW 2026"
                 Set to "" (empty string) to hide it
    featured   → Model name shown in the panel heading
    sub        → One sentence tagline under the heading
    price      → Featured / starting price shown large
    rows       → Up to 3 models shown in the table
                 Format: [ ["Model Name", "$X,XXX"], ... ]
=======================================================
*/
(function () {
  var MENU_ID = 'tmenu-tabpanel-tmenu-menu-433671';
  var triggerSelector = '.tmenu_item_level_2.tmenu_item_layout_imgswap';
  var productSelector = '.tmenu_item_level_2.tmenu_item_layout_product';
  var htmlSelector    = '.tmenu_item_level_2.tmenu_item_layout_html';

  // Extract a brand key from a /collections/<brand> or /products/<brand>-... link
  function brandFromHref(el, type) {
    var a = (el.matches && el.matches('a')) ? el : el.querySelector('a');
    var href = a ? (a.getAttribute('href') || '') : '';
    var m = href.match(new RegExp('/' + type + '/([a-z0-9]+)', 'i'));
    return m ? m[1].toLowerCase() : null;
  }

  // Show only the product matching `brand` and hide the HTML block.
  // Pass brand = null to reset: hide all products, restore the HTML block.
  function apply(menu, brand) {
    menu.querySelectorAll(productSelector).forEach(function (p) {
      if (brand && brandFromHref(p, 'products') === brand) {
        p.style.setProperty('display', 'flex', 'important');
      } else {
        p.style.setProperty('display', 'none', 'important');
      }
    });

    menu.querySelectorAll(htmlSelector).forEach(function (h) {
      if (brand) h.style.setProperty('display', 'none', 'important'); // hide while previewing a product
      else h.style.removeProperty('display');                        // restore on reset
    });
  }

  function ctx(node) {
    if (!node || !node.closest) return null;
    var trigger = node.closest(triggerSelector);
    if (!trigger) return null;
    var menu = trigger.closest('#' + MENU_ID);
    return menu ? { trigger: trigger, menu: menu } : null;
  }

  document.addEventListener('mouseover', function (e) {
    var c = ctx(e.target);
    if (c) apply(c.menu, brandFromHref(c.trigger, 'collections'));
  });

  document.addEventListener('mouseout', function (e) {
    var c = ctx(e.target);
    if (!c) return;
    if (e.relatedTarget && c.trigger.contains(e.relatedTarget)) return; // ignore moves within same trigger
    apply(c.menu, null);
  });
})();

(function () {

  /* ============================================================
     BRAND DATA — FILL IN YOUR VALUES HERE
     ============================================================ */
  var ijmmBrands = [
    /* 0 — Phonak */
    {
      name:       "Phonak",
      logoUrl:    "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/Phonak_Logo.png",
      productImg: "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/fc15d163-Phonak-Audeo-R-Infinio-5.png",
      href:       "/collections/phonak",
      badge:      "BESTSELLER",
      featured:   "Audéo Lumity",
      sub:        "Bluetooth streaming & hands-free calling with rechargeable convenience.",
      price:      "$2,499",
      totalModels: 8,
      rows: [
        ["Audéo Lumity",   "$2,499"],
        ["Audéo Paradise", "$1,999"],
        ["Naída Lumity",   "$2,699"]
      ]
    },
    /* 1 — Starkey (default active) */
    {
      name:       "Starkey",
      logoUrl:    "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/starkey-logo.webp",
      productImg: "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/Starkey-Evolv-AI-champagne-single.png",
      href:       "/collections/starkey",
      badge:      "NEW 2026",
      featured:   "Edge AI",
      sub:        "Edge Mode+ for instant clarity in any room.",
      price:      "$2,799",
      totalModels: 9,
      rows: [
        ["Edge AI",     "$2,799"],
        ["Genesis AI",  "$2,299"],
        ["Evolv AI",    "$1,899"]
      ]
    },
    /* 2 — ReSound */
    {
      name:       "ReSound",
      logoUrl:    "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/resound-logo-colored.svg",
      productImg: "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/ReSound-Omnia-Colors8.png",
      href:       "/collections/resound",
      badge:      "EDITOR PICK",
      featured:   "OMNIA",
      sub:        "Full surround sound & direct streaming to iPhone and Android.",
      price:      "$2,599",
      totalModels: 9,
      rows: [
        ["OMNIA", "$2,599"],
        ["ONE",   "$2,199"],
        ["Key",   "$1,699"]
      ]
    },
    /* 3 — Oticon */
    {
      name:       "Oticon",
      logoUrl:    "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/Oticon-logo.jpg",
      productImg: "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/Silver_8497ffeb-9ce0-4702-8893-79c8f31d7d77.png",
      href:       "/collections/oticon",
      badge:      "FEATURED",
      featured:   "Real",
      sub:        "Real Sound Technology for richer, more natural speech clarity.",
      price:      "$2,399",
      totalModels: 3,
      rows: [
        ["Real", "$2,399"],
        ["More", "$1,899"],
        ["Own",  "$1,499"]
      ]
    },
    /* 4 — Signia */
    {
      name:       "Signia",
      logoUrl:    "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/signia.svg",
      productImg: "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/fd946065-signia_feature_image-removebg-preview.png",
      href:       "/collections/signia",
      badge:      "MOST INVISIBLE",
      featured:   "Pure Charge&Go AX",
      sub:        "Split processing separates speech from background noise automatically.",
      price:      "$2,349",
      totalModels: 11,
      rows: [
        ["Pure Charge&Go AX", "$2,349"],
        ["Styletto AX",       "$2,499"],
        ["Insio AX",          "$1,999"]
      ]
    },
    /* 5 — Sennheiser */
    {
      name:       "Sennheiser",
      logoUrl:    "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/OIP.webp",
      productImg: "https://cdn.shopify.com/s/files/1/0994/9688/6553/files/sennheiser-no-background.png",
      href:       "/collections/sennheiser",
      badge:      "AUDIOPHILE",
      featured:   "All-Day Clear",
      sub:        "Precision audio engineering crafted for everyday hearing clarity.",
      price:      "$1,499",
      totalModels: 1,
      rows: [
        ["All-Day Clear", "$1,499"]
      ]
    }
  ];
  /* ============================================================ */

  var activeIndex = -1; // No brand selected by default

  
/* ── Render brand cards into the grid ── */
function renderGrid() {
  var grid = document.getElementById("ijmm-grid");
  if (!grid) return;
  grid.innerHTML = ijmmBrands.map(function (b, i) {
    return '<a class="ijmm-card' + (i === activeIndex ? ' ijmm-active' : '') + '" href="' + b.href + '" data-brand="' + i + '" onmouseenter="ijmmSet(' + i + ')">'
      + '<div class="ijmm-logo-wrap"><img src="' + b.logoUrl + '" alt="' + b.name + '" loading="lazy"></div>'
      + '<span class="ijmm-card-count">' + b.totalModels + ' Model' + (b.totalModels !== 1 ? 's' : '') + '</span>'
      + '</a>';
  }).join('');
}

  /* ── Render the right-side detail panel ── */
  function renderDetail() {
    var detail = document.getElementById("ijmm-detail");
    if (!detail) return;

    if (activeIndex === -1) {
      detail.innerHTML =
        '<div class="ijmm-panel-top">'
        + '<div class="ijmm-panel-text">'
        +   '<div class="ijmm-badge">FIND YOUR HEARING AID</div>'
        +   '<div class="ijmm-panel-title">Hover any brand <span>to preview</span></div>'
        +   '<div class="ijmm-panel-sub">Hover (or tap) a brand to see its flagship aid here.</div>'
        +   '<a class="ijmm-explore-btn" href="/collections/all-hearing-aids">Browse all &rarr;</a>'
        + '</div>'
        + '<div class="ijmm-product-img-wrap">'
        +   '<img src="https://cdn.shopify.com/s/files/1/0994/9688/6553/files/0d3186d2-Phonak-Audeo-R-Infinio-5.png" alt="Hearing aid" loading="lazy">'
        + '</div>'
        + '</div>'
        + '<div class="ijmm-panel-bottom ijmm-panel-placeholder">'
        + '<div class="ijmm-models-header">'
        +   '<span class="ijmm-models-label">TOP MODELS</span>'
        + '</div>'
        + '<div class="ijmm-placeholder-hint">Hover a brand to see top models</div>'
        + '</div>';
      return;
    }

    var b = ijmmBrands[activeIndex];

    var badgeHtml = b.badge
      ? '<div class="ijmm-badge">' + b.badge + '</div>'
      : '';

    var rowsHtml = b.rows.map(function (r) {
      return '<div class="ijmm-model-row">'
        + '<span class="ijmm-model-name">' + r[0] + '</span>'
        + '<span class="ijmm-model-price">' + r[1] + '</span>'
        + '</div>';
    }).join('');

    detail.innerHTML =
      '<div class="ijmm-panel-top">'
      + '<div class="ijmm-panel-text">'
      +   badgeHtml
      +   '<div class="ijmm-panel-title"><span>' + b.name + '</span> ' + b.featured + '</div>'
      +   '<div class="ijmm-panel-sub">' + b.sub + '</div>'
      +   '<div class="ijmm-price">' + b.price + '<span class="ijmm-price-unit"> /pair</span></div>'
      +   '<a class="ijmm-explore-btn" href="' + b.href + '">Explore &rarr;</a>'
      + '</div>'
      + '<div class="ijmm-product-img-wrap">'
      +   '<img src="' + b.productImg + '" alt="' + b.name + ' ' + b.featured + '" loading="lazy">'
      + '</div>'
      + '</div>'
      + '<div class="ijmm-panel-bottom">'
      + '<div class="ijmm-models-header">'
      +   '<span class="ijmm-models-label">' + b.name + ' Models</span>'
      +   '<a class="ijmm-view-all" href="' + b.href + '">View all ' + b.totalModels + ' &rarr;</a>'
      + '</div>'
      + rowsHtml
      + '</div>';
  }

  /* ── Update active card highlight ── */
  function updateCards() {
    var cards = document.querySelectorAll('#ijmm-grid .ijmm-card');
    cards.forEach(function (card, idx) {
      card.classList.toggle('ijmm-active', idx === activeIndex);
    });
  }

  /* ── Public function called by onmouseenter in the HTML block ── */
  window.ijmmSet = function (index) {
    if (index === activeIndex) return;
    activeIndex = index;
    updateCards();
    renderDetail();
  };

  /* ── Init on DOM ready ── */
  /* ── Init: wait for Qikify to inject the menu DOM ── */
  function init() {
    var detail = document.getElementById("ijmm-detail");
    if (!detail) return false;
    renderGrid();
    renderDetail();
    return true;
  }

  // Try immediately in case DOM is already ready
  if (!init()) {
    // Qikify injects menu HTML after page load — watch for it
    var observer = new MutationObserver(function () {
      if (init()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

})();